var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import TRANSLATIONS_EN from "./en.json";
import TRANSLATIONS_ES from "./es.json";
import TRANSLATIONS_POR from "./por.json";
import TRANSLATIONS_AR from "./ar.json";
import TRANSLATIONS_FR from "./fr.json";
import TRANSLATIONS_JP from "./ja.json";
import moment from "moment";
// Import the locales you actually support
import "moment/locale/es";
import "moment/locale/pt";
import "moment/locale/ar";
import "moment/locale/fr";
import "moment/locale/ja";
const loadChildTranslations = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { default: importTranslations } = yield import("adrinWebApp/Translations");
        const translations = yield importTranslations();
        console.log("Loaded child translations:", translations);
        return translations;
    }
    catch (error) {
        console.error("Error loading translations from child app:", error);
        return null;
    }
});
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    fallbackLng: "en",
    load: "currentOnly",
    resources: {
        en: {
            translation: TRANSLATIONS_EN,
        },
        es: {
            translation: TRANSLATIONS_ES,
        },
        pt: {
            translation: TRANSLATIONS_POR,
        },
        ar: {
            translation: TRANSLATIONS_AR,
        },
        fr: {
            translation: TRANSLATIONS_FR,
        },
        ja: {
            translation: TRANSLATIONS_JP,
        },
    },
    interpolation: {
        escapeValue: false,
    },
});
loadChildTranslations().then((childTranslations) => {
    if (childTranslations) {
        console.log(childTranslations, 'child translations');
        Object.entries(childTranslations).forEach(([lang, translation]) => {
            i18n.addResourceBundle(lang, "translation", translation, true, true);
        });
    }
    else {
        console.warn("Child translations are not available.");
    }
});
moment.locale(i18n.language || "en");
// Keep moment in sync when language changes
i18n.on("languageChanged", (lng) => {
    moment.locale(lng || "en");
});
export default i18n;
